/**
 * Базовый URL бэкенда для сгенерированного клиента.
 *
 * По умолчанию пустая строка: клиент шлёт запрос на тот же origin (пути в SDK уже
 * начинаются с /api/). Локально /api проксирует dev-сервер Vite, на стендах - nginx
 * стенда, без переписывания пути. Браузер видит один origin, CORS не нужен, и один
 * образ фронта годится для любого окружения.
 *
 * VITE_API_BASE_URL - на особый случай, когда фронт и API живут на разных origin.
 * Тогда адрес зашивается при сборке, а CORS на бэкенде обязателен.
 */
export const resolveApiBaseUrl = (): string =>
  import.meta.env.VITE_API_BASE_URL ?? '';
